module.exports = __webpack_public_path__ + "static/img/icon-bar.d44da6ab.png";